import { GridEventListener, GridRowParams } from '@mui/x-data-grid';

import { RecapAsset } from '@/api/trading/types';
import { useSignup } from '@/blocks/components/PlatformLink';
import { useTemplatePagesRouter } from '@/navigation';
import { useAnalytics } from '@/providers/analytics/WithAnalytics';
import { EventBlockNames } from '@/providers/analytics/types';

export { DataGridWrapper } from './DataGrid';
export { getColDef } from '@/blocks/components/DataGrid/shared/getColDef';
export { useColumnsVisibilityModel } from '@/blocks/components/DataGrid/shared/useColumnsVisibilityModel';
export { WithSkeleton } from '@/blocks/components/DataGrid/shared/WithSkeleton';

export const DEFAULT_DATAGRID_PAGE_SIZE = 15;

export function useRowClick() {
  const { openSignupWithAsset } = useSignup();
  const { openStrategyPage, openCoinPage } = useTemplatePagesRouter();
  const { track } = useAnalytics();

  const openSignupOnAssetRowClick: GridEventListener<'rowClick'> = (props: GridRowParams<RecapAsset>, e) => {
    if (!(e.target as HTMLAnchorElement).href) {
      track({
        event_label: props.row.name,
        event_block_name: EventBlockNames.assets_table,
      });
      openSignupWithAsset({ asset: props.row, newTab: e.metaKey });
    }
  };

  const openStrategyPageOnRowClick: GridEventListener<'rowClick'> = (
    props: GridRowParams<{ strategyId: string }>,
    e,
  ) => {
    if (!(e.target as HTMLAnchorElement).href) {
      openStrategyPage(props.row.strategyId, e.metaKey);
    }
  };

  const openCoinPageOnRowClick: GridEventListener<'rowClick'> = (
    props: GridRowParams<{ name: string; platform: string }>,
    e,
  ) => {
    if (!(e.target as HTMLAnchorElement).href) {
      track({
        event_label: props.row.name,
        event_block_name: EventBlockNames.assets_table,
      });
      openCoinPage(props.row.name, e.metaKey);
    }
  };

  return {
    openSignupOnRowClick: openSignupOnAssetRowClick,
    openStrategyPageOnRowClick,
    openCoinPageOnRowClick,
  };
}
